module.exports = __webpack_public_path__ + "img/public_dropdown_up_white.d40f14a7.svg";